var _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCellPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 63,
    viewBox: "0 0 42 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.8403,
    y: 12.1639,
    width: 29.6596,
    height: 50.5957,
    rx: 2,
    fill: "#8894AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5852,
    y: 13.9086,
    width: 26.1702,
    height: 43.617,
    rx: 2,
    fill: "#F1F5FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0532,
    y: 59.2703,
    width: 5.23404,
    height: 1.74468,
    rx: 0.87234,
    fill: "#F1F5FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28335_828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1036 39.0974C33.1036 39.3866 32.9887 39.664 32.7842 39.8685C32.5797 40.073 32.3023 40.1878 32.0131 40.1878H22.1993C21.9101 40.1878 21.6328 40.073 21.4283 39.8685C21.2238 39.664 21.1089 39.3866 21.1089 39.0974V33.1001C21.1089 32.8109 21.2238 32.5335 21.4283 32.329C21.6328 32.1245 21.9101 32.0096 22.1993 32.0096H24.3802L25.4706 30.374H28.7419L29.8323 32.0096H32.0131C32.3023 32.0096 32.5797 32.1245 32.7842 32.329C32.9887 32.5335 33.1036 32.8109 33.1036 33.1001V39.0974Z",
    stroke: "#8894AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1064 38.007C28.3108 38.007 29.2872 37.0306 29.2872 35.8261C29.2872 34.6217 28.3108 33.6453 27.1064 33.6453C25.9019 33.6453 24.9255 34.6217 24.9255 35.8261C24.9255 37.0306 25.9019 38.007 27.1064 38.007Z",
    stroke: "#8894AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9885 11.2103L6.05382 6.27562",
    stroke: "#FFD661",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44642 12.7524L3.89488 12.7524",
    stroke: "#FFD661",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8391 9.35979L12.8391 4.42509",
    stroke: "#FFD661",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5825 9.61366L17.4379 6.75565",
    stroke: "#FFD661",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40454 15.9152L6.97027 18.2995",
    stroke: "#FFD661",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28335_828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0851,
    height: 13.0851,
    fill: "white",
    transform: "translate(20.5637 28.7384)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCellPhone);
export default __webpack_public_path__ + "static/media/photo-cell-phone.f7fd5ef74d031fa90d5af655d8aadb2e.svg";
export { ForwardRef as ReactComponent };